import { Form, Input, Row, Col, Switch, InputNumber, ColorPicker, Select, DatePicker } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../system/WebEditUniversalNewEx';
import fetchApi from '../../utils/api/fetchApi';
import getList from '../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const ref = useRef<any>(undefined);

    const faPiaoDownloadUrl = Form.useWatch('faPiaoDownloadUrl', form);
    const faPiaoQrCodeUrl = Form.useWatch('faPiaoQrCodeUrl', form);
    const redFaPiaoQrCodeUrl = Form.useWatch('redFaPiaoQrCodeUrl', form);

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();

    const [faPiaoSupplierData, setFaPiaoSupplierData] = useState<any>();
    const [faPiaoTypeData, setFaPiaoTypeData] = useState<any>();
    const [faPiaoQrCodeStatusData, setFaPiaoQrCodeStatusData] = useState<any>();
    const [faPiaoStatusData, setFaPiaoStatusData] = useState<any>();
    const [platformData, setPlatformData] = useState<any>();
    const [merchantData, setMerchantData] = useState<any>();
    const [merchantOrderTypeData, setMerchantOrderTypeData] = useState<any>();
    const [shopData, setShopData] = useState<any>();

    useEffect(() => {
        let serviceUrl;
        if (ref.current) {
            serviceUrl = ref.current.defaultService;
            setDefaultService(serviceUrl);
            setInitData(() => ref.current.initData);
            ref.current.row.then((res: any) => {
                if (res.success === true) {
                    const { faPiaoDownloadUrl, faPiaoQrCodeUrl, buyerTaxId, buyerPhone, buyerAddress, buyerBankName, buyerBankAccountNumber,
                        sellerTaxId, sellerPhone, sellerAddress, sellerBankName, sellerBankAccountNumber, redFaPiaoQrCodeUrl } = res.data
                    form.setFieldValue('faPiaoDownloadUrl', atob(faPiaoDownloadUrl));
                    form.setFieldValue('faPiaoQrCodeUrl', atob(faPiaoQrCodeUrl));
                    form.setFieldValue('redFaPiaoQrCodeUrl', atob(redFaPiaoQrCodeUrl));
                    form.setFieldValue('buyerInfo', `纳税人识别号：${buyerTaxId}；电话：${buyerPhone}；地址：${buyerAddress}；开户行：${buyerBankName}；银行账号：${buyerBankAccountNumber}；`);
                    form.setFieldValue('sellerInfo', `纳税人识别号：${sellerTaxId}；电话：${sellerPhone}；地址：${sellerAddress}；开户行：${sellerBankName}；银行账号：${sellerBankAccountNumber}；`);
                }
            })
        }
        fetchApi.GET(serviceUrl,
            {
                apiId: 'generalData',
                apiVariable: 'faPiaoSupplier@faPiaoType@faPiaoQrCodeStatus@faPiaoStatus@platform',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success === true) {
                    const { faPiaoSupplier, faPiaoType, faPiaoQrCodeStatus, faPiaoStatus, platform } = res.data;
                    setFaPiaoSupplierData(faPiaoSupplier);
                    setFaPiaoTypeData(faPiaoType);
                    setFaPiaoQrCodeStatusData(faPiaoQrCodeStatus);
                    setFaPiaoStatusData(faPiaoStatus);
                    setPlatformData(platform);
                }
            })
        fetchApi.GET(serviceUrl,
            {
                apiId: 'merchant',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMerchantData(res.data);
                }
            })
        fetchApi.GET(serviceUrl,
            {
                apiId: 'merchantOrderType',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMerchantOrderTypeData(res.data);
                }
            })
        fetchApi.GET(serviceUrl,
            {
                apiId: 'shop',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setShopData(res.data);
                }
            })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'faPiao',
        serviceId: 'business',
        dateColumnName: ['issueDate', 'openQrCodeDate', 'invalidQrCodeDate', 'redTime']
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '发票'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1180}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={6}>
                            <Form.Item
                                label="id"
                                name="id" >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="供应商"
                                name="faPiaoSupplierId">
                                <Select
                                    showSearch
                                    placeholder="发票供应商"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(faPiaoSupplierData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="类型"
                                name="faPiaoTypeId">
                                <Select
                                    showSearch
                                    placeholder="发票类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(faPiaoTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="发票代码"
                                name="faPiaoCode">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="发票号码"
                                name="faPiaoNumber">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="开票金额"
                                name="totalAmount"
                                tooltip='开票金额（含税）'>
                                <InputNumber
                                    style={{ width: 190 }} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="开票日期"
                                name="issueDate">
                                <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="​发票状态"
                                name="faPiaoStatusId">
                                <Select
                                    showSearch
                                    placeholder="​发票状态"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(faPiaoStatusData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="发票流水号"
                                name="faPiaoSerialNo">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={9}>
                            <Form.Item
                                label="购买方邮箱"
                                name="buyerEmail">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="邮件发送数"
                                name="numberOfSendMail">
                                <InputNumber
                                    style={{ width: 110 }} />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="购买方名称"
                                name="buyerName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item
                                label="购买方资料"
                                name="buyerInfo">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="销售方名称"
                                name="sellerName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item
                                label="销售方资料"
                                name="sellerInfo">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="备注"
                                name="remarks">
                                < Input.TextArea autoSize={{ minRows: 1, maxRows: 10 }} />
                            </Form.Item>
                        </Col>
                        <Col span={16}>
                            <Form.Item
                                label="发票地址"
                                name="faPiaoDownloadUrl">
                                <div style={{ padding: '8px 0' }}>
                                    <a
                                        href={faPiaoDownloadUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'underline',
                                            color: '#1890ff',
                                            wordBreak: 'break-all'
                                        }}
                                    >
                                        {faPiaoDownloadUrl}
                                    </a>
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="冲红日期"
                                name="redTime">
                                <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={18}>
                            <Form.Item
                                label="红票地址"
                                name="redFaPiaoQrCodeUrl">
                                <div style={{ padding: '8px 0' }}>
                                    <a
                                        href={redFaPiaoQrCodeUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'underline',
                                            color: '#1890ff',
                                            wordBreak: 'break-all'
                                        }}
                                    >
                                        {redFaPiaoQrCodeUrl}
                                    </a>
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="关键id"
                                name="keyId"
                                tooltip='关键id，例如：unionId'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="平台"
                                name="platformId">
                                <Select
                                    showSearch
                                    placeholder="平台"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(platformData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="商户"
                                name="merchantId">
                                <Select
                                    showSearch
                                    placeholder="商户"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(merchantData, { itemName: 'merchantName', includeNull: true })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="店铺"
                                name="shopId">
                                <Select
                                    showSearch
                                    placeholder="店铺"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(shopData, { itemName: 'shopName', includeNull: true })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="单类型"
                                name="merchantOrderTypeId"
                                tooltip='商户单类型'>
                                <Select
                                    showSearch
                                    placeholder="单类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(merchantOrderTypeData, { itemName: 'orderTypeName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="商户单号"
                                name="merchantOrderId"
                                tooltip='商户单号'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="开票人id"
                                name="drawerId">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="开票人名称"
                                name="drawerName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="收款人名称"
                                name="payeeName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="复核人名称"
                                name="reviewerName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="​二维码状态"
                                name="faPiaoQrCodeStatusId"
                                tooltip='开发票二维码状态'>
                                <Select
                                    showSearch
                                    placeholder="开发票二维码状态"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(faPiaoQrCodeStatusData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="开二维码日期"
                                name="openQrCodeDate"
                                tooltip='开发票二维码日期'>
                                <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="作废日期"
                                name="invalidQrCodeDate"
                                tooltip='作废开票二维码日期'>
                                <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="提取码"
                                tooltip='提取码，发票夹，公众号提取码开票处使用'
                                name="extractCode">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="开票二维码id"
                                name="faPiaoQrCodeId">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={11}>
                            <Form.Item
                                label="开票地址"
                                name="faPiaoQrCodeUrl">
                                <div style={{ padding: '8px 0' }}>
                                    <a
                                        href={faPiaoQrCodeUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'underline',
                                            color: '#1890ff',
                                            wordBreak: 'break-all'
                                        }}
                                    >
                                        {faPiaoQrCodeUrl}
                                    </a>
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="开票二维码"
                                name="faPiaoQrCode"
                                valuePropName="checked"
                                initialValue={true}>
                                <img
                                    src={`data:image/png;base64,${form.getFieldValue('faPiaoQrCode')}`}
                                    alt="QR Code"
                                    style={{ width: 100, height: 100 }}
                                />
                            </Form.Item>
                        </Col>



                        {/* <Col span={5}>
                            <Form.Item
                                label="红票二维码"
                                name="redFaPiaoQrCode"
                                valuePropName="checked"
                                initialValue={true}>
                                <img
                                    src={`data:image/png;base64,${form.getFieldValue('redFaPiaoQrCode')}`}
                                    alt="QR Code"
                                    style={{ width: 100, height: 100 }}
                                />
                            </Form.Item>
                        </Col> */}

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;